module.exports = __webpack_public_path__ + "img/5.e88f0d24.jpg";